import {
    SummaryCategoryEnumType,
    UnitStateGroupEnumType,
    UnitStateGroupEnum,
    MapGpsTypeEnumType,
} from '@mark43/cad-api';
import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../configurations';
import type { LabelClassProperties, UnitIconType } from '../types';
import { AgencyTypeGlobal, globalAttributes } from '../../common/global-attributes';
import { colors } from '../../colors/colors';

// Police Available Online
import policeAvailableOnlineInactive from '../images/unit-icons/police/online/available/police_available_online_inactive.svg';
import policeAvailableOnlineSelected from '../images/unit-icons/police/online/available/police_available_online_selected.svg';
// Police Available Offline
import policeAvailableOfflineInactive from '../images/unit-icons/police/offline/available/police_available_offline_inactive.svg';
import policeAvailableOfflineSelected from '../images/unit-icons/police/offline/available/police_available_offline_selected.svg';
// Police Unavailable Online
import policeUnavailableOnlineInactive from '../images/unit-icons/police/online/unavailable/police_unavailable_online_inactive.svg';
import policeUnavailableOnlineSelected from '../images/unit-icons/police/online/unavailable/police_unavailable_online_selected.svg';
import policeUnavailableOnlineAlternate from '../images/unit-icons/police/online/unavailable/police_unavailable_online_alternate.gif';
// Police Unvailable Offline
import policeUnavailableOfflineInactive from '../images/unit-icons/police/offline/unavailable/police_unavailable_offline_inactive.svg';
import policeUnavailableOfflineSelected from '../images/unit-icons/police/offline/unavailable/police_unavailable_offline_selected.svg';
import policeUnavailableOfflineAlternate from '../images/unit-icons/police/offline/unavailable/police_unavailable_offline_alternate.gif';
// Police Unmanned Online
import policeUnmannedOnlineInactive from '../images/unit-icons/police/online/unmanned/police_unmanned_online_inactive.svg';
import policeUnmannedOnlineSelected from '../images/unit-icons/police/online/unmanned/police_unmanned_online_selected.svg';
// Police Unmanned Offline
import policeUnmannedOfflineInactive from '../images/unit-icons/police/offline/unmanned/police_unmanned_offline_inactive.svg';
import policeUnmannedOfflineSelected from '../images/unit-icons/police/offline/unmanned/police_unmanned_offline_selected.svg';
// Police On Foot Unavailable
import policeOnFootOnlineInactive from '../images/unit-icons/police/on-foot/unavailable/police_on_foot_unavailable_online_inactive.svg';
import policeOnFootOnlineSelected from '../images/unit-icons/police/on-foot/unavailable/police_on_foot_unavailable_online_selected.svg';
// Police On Foot Available
import policeOnFootOnlineAvailableInactive from '../images/unit-icons/police/on-foot/available/police_on_foot_available_online_inactive.svg';
import policeOnFootOnlineAvailableSelected from '../images/unit-icons/police/on-foot/available/police_on_foot_available_online_selected.svg';
// Police On Foot Offline
import policeOnFootOfflineInactive from '../images/unit-icons/police/offline/on-foot/police_on_foot_offline_inactive.svg';
import policeOnFootOfflineSelected from '../images/unit-icons/police/offline/on-foot/police_on_foot_offline_selected.svg';
// Fire Available Online
import fireAvailableOnlineInactive from '../images/unit-icons/fire/online/available/fire_available_online_inactive.svg';
import fireAvailableOnlineSelected from '../images/unit-icons/fire/online/available/fire_available_online_selected.svg';
// Fire Available Offline
import fireAvailableOfflineInactive from '../images/unit-icons/fire/offline/available/fire_available_offline_inactive.svg';
import fireAvailableOfflineSelected from '../images/unit-icons/fire/offline/available/fire_available_offline_selected.svg';
// Fire Unavailable Online
import fireUnavailableOnlineInactive from '../images/unit-icons/fire/online/unavailable/fire_unavailable_online_inactive.svg';
import fireUnavailableOnlineSelected from '../images/unit-icons/fire/online/unavailable/fire_unavailable_online_selected.svg';
import fireUnavailableOnlineAlternate from '../images/unit-icons/fire/online/unavailable/fire_unavailable_online_alternate.gif';
// Fire Unavailable Offline
import fireUnavailableOfflineInactive from '../images/unit-icons/fire/offline/unavailable/fire_unavailable_offline_inactive.svg';
import fireUnavailableOfflineSelected from '../images/unit-icons/fire/offline/unavailable/fire_unavailable_offline_selected.svg';
import fireUnavailableOfflineAlternate from '../images/unit-icons/fire/offline/unavailable/fire_unavailable_offline_alternate.gif';
// Fire Unmanned Online
import fireUnmannedOnlineInactive from '../images/unit-icons/fire/online/unmanned/fire_unmanned_online_inactive.svg';
import fireUnmannedOnlineSelected from '../images/unit-icons/fire/online/unmanned/fire_unmanned_online_selected.svg';
// Fire Unmanned Offline
import fireUnmannedOfflineInactive from '../images/unit-icons/fire/offline/unmanned/fire_unmanned_offline_inactive.svg';
import fireUnmannedOfflineSelected from '../images/unit-icons/fire/offline/unmanned/fire_unmanned_offline_selected.svg';
// EMS Available Online
import emsAvailableOnlineInactive from '../images/unit-icons/ems/online/available/ems_available_online_inactive.svg';
import emsAvailableOnlineSelected from '../images/unit-icons/ems/online/available/ems_available_online_selected.svg';
// EMS Available Offline
import emsAvailableOfflineInactive from '../images/unit-icons/ems/offline/available/ems_available_offline_inactive.svg';
import emsAvailableOfflineSelected from '../images/unit-icons/ems/offline/available/ems_available_offline_selected.svg';
// EMS Unavailable Online
import emsUnavailableOnlineInactive from '../images/unit-icons/ems/online/unavailable/ems_unavailable_online_inactive.svg';
import emsUnavailableOnlineSelected from '../images/unit-icons/ems/online/unavailable/ems_unavailable_online_selected.svg';
import emsUnavailableOnlineAlternate from '../images/unit-icons/ems/online/unavailable/ems_unavailable_online_alternate.gif';
// EMS Unavailable Offline
import emsUnavailableOfflineInactive from '../images/unit-icons/ems/offline/unavailable/ems_unavailable_offline_inactive.svg';
import emsUnavailableOfflineSelected from '../images/unit-icons/ems/offline/unavailable/ems_unavailable_offline_selected.svg';
import emsUnavailableOfflineAlternate from '../images/unit-icons/ems/offline/unavailable/ems_unavailable_offline_alternate.gif';

export const unitUniqueValueInfos = [
    // Police
    // Available
    // Online
    {
        value: 'Police, Available, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeAvailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Available, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeAvailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Police, Available, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeAvailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Available, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeAvailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Unavailable
    // Online
    {
        value: 'Police, Unavailable, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Online, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOnlineAlternate,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Online, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Police, Unavailable, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Offline, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOfflineAlternate,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unavailable, Offline, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: policeUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Unmanned
    // Online
    {
        value: 'Police, Unmanned, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeUnmannedOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unmanned, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeUnmannedOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Police, Unmanned, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeUnmannedOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Unmanned, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeUnmannedOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // On Foot
    // Online
    {
        value: 'Police, On Foot, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOnlineInactive,
            width: '48px',
            height: '48px',
        },
    },
    {
        value: 'Police, On Foot, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOnlineSelected,
            width: '48px',
            height: '48px',
        },
    },
    // Online Available
    {
        value: 'Police, On Foot Available, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOnlineAvailableInactive,
            width: '48px',
            height: '48px',
        },
    },
    {
        value: 'Police, On Foot Available, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOnlineAvailableSelected,
            width: '48px',
            height: '48px',
        },
    },
    // Offline
    {
        value: 'Police, On Foot, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOfflineInactive,
            width: '48px',
            height: '48px',
        },
    },
    {
        value: 'Police, On Foot, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeOnFootOfflineSelected,
            width: '48px',
            height: '48px',
        },
    },
    // Fire
    // Available
    // Online
    {
        value: 'Fire, Available, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireAvailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Available, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireAvailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Fire, Available, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireAvailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Available, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireAvailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Unavailable
    // Online
    {
        value: 'Fire, Unavailable, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Online, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOnlineAlternate,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Online, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Fire, Unavailable, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Offline, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOfflineAlternate,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unavailable, Offline, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: fireUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Unmanned
    // Online
    {
        value: 'Fire, Unmanned, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireUnmannedOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unmanned, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireUnmannedOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // Offline
    {
        value: 'Fire, Unmanned, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireUnmannedOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Unmanned, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireUnmannedOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    // EMS
    {
        value: 'EMS, Available, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: emsAvailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Available, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: emsAvailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Available, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: emsAvailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Available, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: emsAvailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Online, Inactive',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOnlineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Online, Selected',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Online, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOnlineAlternate,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Online, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOnlineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Offline, Inactive',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOfflineInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Offline, Selected',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Offline, Inactive, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOfflineAlternate,
            width: '32x',
            height: '32px',
        },
    },
    {
        value: 'EMS, Unavailable, Offline, Selected, EN_ROUTE_ALTERNATE',
        symbol: {
            type: 'picture-marker',
            url: emsUnavailableOfflineSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const unitUniqueInfosByValueKey = Object.values(unitUniqueValueInfos).reduce((acc, cur) => {
    acc[cur.value] = cur.symbol.url;
    return acc;
}, {} as Record<string, string>);

export const agencyDefaultUnitIcon: Record<AgencyTypeGlobal, string> = {
    [globalAttributes.agencyTypeGlobal.POLICE]: policeAvailableOnlineInactive,
    [globalAttributes.agencyTypeGlobal.FIRE]: fireAvailableOnlineInactive,
    [globalAttributes.agencyTypeGlobal.EMS]: emsAvailableOnlineInactive,
};

export const unitIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        // used when item field dont match anything defined in uniqueValueInfos
        type: 'simple-marker',
        width: '32px',
        height: '32px',
        color: colors.mapLabelDefault,
    },
    uniqueValueInfos: unitUniqueValueInfos,
    authoringInfo: undefined,
};

function isUnitStatusGroupShownAsAvailableIcon(unitStateGroup: UnitStateGroupEnumType): boolean {
    switch (unitStateGroup) {
        case UnitStateGroupEnum.AVAILABLE.name:
        case UnitStateGroupEnum.DISPATCHED.name:
            return true;
        default:
            return false;
    }
}

/** This function maps the different units to one of the 4 unique icon types we will render */
export function getUnitIconType(
    unitStateGroup: UnitStateGroupEnumType,
    unitType: MapGpsTypeEnumType,
    summaryCategory: SummaryCategoryEnumType
): UnitIconType {
    const isAvailableIcon = isUnitStatusGroupShownAsAvailableIcon(unitStateGroup);
    if (unitType === 'USER' && isAvailableIcon) {
        return 'On Foot Available';
    } else if (unitType === 'USER') {
        return 'On Foot';
    } else if (summaryCategory === 'UNIT_UNMANNED' || summaryCategory === 'FIRE_UNIT_UNMANNED') {
        return 'Unmanned';
    } else if (
        !isAvailableIcon ||
        summaryCategory === 'UNIT_ASSIGNED' ||
        summaryCategory === 'FIRE_UNIT_ASSIGNED' ||
        summaryCategory === 'EMS_UNIT_ASSIGNED' ||
        summaryCategory === 'UNIT_ADMIN' ||
        summaryCategory === 'UNIT_SPECIAL_ASSIGNMENT'
    ) {
        return 'Unavailable';
    } else {
        return 'Available';
    }
}

const inactiveUnitIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelText,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'below-center',
    labelExpressionInfo: {
        expression: `$feature.callsign + $feature.eventPriorityString`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState<>'Selected'`,
};

const selectedUnitIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelAlert,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
        yoffset: 7,
    },
    deconflictionStrategy: 'static',
    labelPlacement: 'below-center',
    labelExpressionInfo: {
        expression: `$feature.callsign + $feature.eventPriorityString`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState='Selected'`,
};

// all of the unit label classes to be used as the labelingInfo property on the unit feature layer
export const unitIconLabels = [inactiveUnitIconLabel, selectedUnitIconLabel];
